<template>
  <div class="screen-container">
    <!-- 顶部标题区域 -->
    <header class="header">
      <h1>临床数据库全链条数据中心</h1>
      <div class="back">
        <img src="@/assets/cockpit/t-b-b.png" class="t-b-b" alt="">
        <img src="@/assets/cockpit/t-b-r.png" class="t-b-r" alt="">
        <img src="@/assets/cockpit/t-b-l.png" class="t-b-l" alt="">
      </div>
      <img src="@/assets/cockpit/l-t.png" class="l-t" alt="">
      <img src="@/assets/cockpit/r-t.png" class="r-t" alt="">
      <img src="@/assets/cockpit/l-d.png" class="l-d" alt="">
      <img src="@/assets/cockpit/r-d.png" class="r-d" alt="">
    </header>
    <!-- 底部背景图 -->
    <div class="footer-back">
      <img src="@/assets/cockpit/b-d.png" class="b-d" alt="">
      <img src="@/assets/cockpit/l-b.png" class="l-b" alt="">
      <img src="@/assets/cockpit/r-b.png" class="r-b" alt="">
    </div>
    <div class="back-root"></div>

    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 第一行：项目总览 -->
      <div class="c-title">
        <img src="@/assets/cockpit/t-b.png" class="t-b" alt="">
        <span class="t-text">项目总览</span>
      </div>
      <div class="row row-1 row-gap">
        <!-- 背景颜色浅色 -->
        <div class="card overview-card">
          <div class="back-root" style="top: 50%;left: 50%;"></div>
          <div class="back-root" style="top: 50%;left: 10%;"></div>
          <div class="back-root" style="top: 50%;left: 100%;"></div>
          <div class="overview-stats">
            <div class="stat-item">
              <img src="@/assets/cockpit/profile.png" alt="">
              <div>
                <div class="stat-label">昨日入组</div>
                <div class="stat-value">{{ groupCount.yesterday_pass }}<span>人</span></div>
              </div>
            </div>
            <div class="stat-item">
              <img src="@/assets/cockpit/profile-2.png" alt="">
              <div>
                <div class="stat-label">当月入组</div>
                <div class="stat-value">{{ groupCount.month_pass }}<span>人</span></div>
              </div>
            </div>
            <div class="stat-item">
              <img src="@/assets/cockpit/profile-3.png" alt="">
              <div>
                <div class="stat-label">总共入组</div>
                <div class="stat-value">{{ groupCount.year_pass }}<span>人</span></div>
              </div>
            </div>
          </div>
          <div class="card-title">中心入组人数分布</div>
          <div class="chart-placeholder" style="height: calc(100% - 100px)" ref="centralGroupChart"></div>
        </div>
        <div class="card trend-card">
          <div class="card-title">中心入组趋势</div>
          <div class="searchtime">
            <div class="item" :class="{ 'active': period5 == item.value }" v-for="item in initDateRange(5)"
              :key="item.value" @click="handlePeriod(5, item)">{{ item.name }}</div>
          </div>
          <div class="chart-placeholder" ref="trendChart"></div>
        </div>

        <div class="card rate-card">
          <div class="card-title">中心应答率/随访率统计</div>
          <div class="chart-placeholder" ref="rateChart"></div>
        </div>
      </div>
      <div class="c-title" style="margin-top: 24px;">
        <img src="@/assets/cockpit/t-b.png" class="t-b" alt="">
        <div class="t-text">{{ selectCenterItem.name || '选择中心' }}
          <div class="center" @click="handleModalFlag">
            切换中心
            <img src="@/assets/cockpit/arrow.png" alt="">
          </div>
        </div>

      </div>
      <!-- 第二行：四川大学华西医院数据 -->
      <div class="row row-2 row-gap">
        <div class="card hospital-info-card">
          <div class="hospital-stats">
            <div class="stat-item">
              <img src="@/assets/cockpit/profile.png" alt="">
              <div class="stat-label">昨日入组</div>
              <div class="stat-value">{{ centerGroupCount.yesterday_pass }}<span>人</span></div>
            </div>
            <div class="stat-item">
              <img src="@/assets/cockpit/profile-2.png" alt="">
              <div class="stat-label">当月入组</div>
              <div class="stat-value">{{ centerGroupCount.month_pass }}<span>人</span></div>
            </div>
            <div class="stat-item">
              <img src="@/assets/cockpit/profile-3.png" alt="">
              <div class="stat-label">总共入组</div>
              <div class="stat-value">{{ centerGroupCount.year_pass }}<span>人</span></div>
            </div>
          </div>
          <div style="flex: 1;display: flex;flex-direction: column;">
            <div class="card-title">受试者性别分布</div>
            <div class="hospital-charts">
              <div class="chart-placeholder" style="z-index: 1;" ref="genderChart"></div>
            </div>
          </div>
          <div style="flex: 1;display: flex;flex-direction: column;">
            <div class="card-title">受试者年龄分布</div>
            <div class="hospital-charts">
              <div class="chart-placeholder" style="z-index: 9;" ref="ageChart"></div>
            </div>
          </div>
        </div>

        <div class="card success-rate-card">
          <div class="card-title">总应答率</div>
          <div class="searchtime">
            <div class="item" :class="{ 'active': period2 == item.value }" v-for="item in initDateRange(2)"
              :key="item.value" @click="handlePeriod(2, item)">{{ item.name }}</div>
          </div>
          <div class="back-root" style="top: 100%;left: -40%;"></div>
          <!-- <div class="back-root" style="top: 100%;left: -100%;"></div>
          <div class="back-root" style="top: 100%;left: -120%;"></div> -->
          <div class="back-root" style="top: 100%;left: 0;"></div>
          <div class="back-root" style="top: 100%;left: 50%;"></div>

          <div class="chart-placeholder" style="margin-top: 10px;" ref="successRateChart"></div>
        </div>
      </div>

      <!-- 第三行：详细数据 -->
      <div class="row row-3">
        <div class="card error-rate-card">
          <div class="card-title">随访率</div>
          <div class="chart-placeholder" style="margin-top: 10px;" ref="errorRateChart"></div>
        </div>

        <div class="card visitor-distribution-card">
          <div class="card-title">调查员入组总人数分布</div>
          <div class="searchtime">
            <div class="item" :class="{ 'active': period1 == item.value }" v-for="item in initDateRange(1)"
              :key="item.value" @click="handlePeriod(1, item)">{{ item.name }}</div>
          </div>
          <div class="back-root" style="top: 100%;left: -40%;"></div>
          <div class="back-root" style="top: 100%;left: -100%;"></div>
          <!-- <div class="back-root" style="top: 100%;left: -120%;"></div> -->
          <div class="back-root" style="top: 100%;left: 0;"></div>
          <div class="back-root" style="top: 100%;left: 50%;"></div>
          <div class="chart-placeholder" style="margin-top: 10px;" ref="visitorDistChart"></div>
        </div>
      </div>

      <!-- 第四行：更多数据 -->
      <div class="row row-4">
        <div class="card average-visitor-card">
          <div class="card-title">调查员平均入组人数趋势</div>
          <div class="searchtime">
            <div class="item" :class="{ 'active': period3 == item.value }" v-for="item in initDateRange(3)"
              :key="item.value" @click="handlePeriod(3, item)">{{ item.name }}</div>
          </div>
          <div class="chart-placeholder" style="margin-top: 10px;" ref="avgVisitorChart"></div>
        </div>

        <div class="card visitor-count-card">
          <div class="card-title">调查员随访人次</div>
          <div class="searchtime">
            <div class="item" :class="{ 'active': period4 == item.value }" v-for="item in initDateRange(4)"
              :key="item.value" @click="handlePeriod(4, item)">{{ item.name }}</div>
          </div>
          <div class="chart-placeholder" style="margin-top: 10px;" ref="visitorCountChart"></div>
        </div>
      </div>
    </main>
    <a-modal v-model:open="modalFlag" title="请选择中心" @ok="handleOk(tempCenterId)">
      <div>
        <div class="select-title">选择中心</div>
        <a-select ref="select" class="select" v-model:value="tempCenterId" style="width: 100%"
          dropdownClassName="select-center-chart">
          <a-select-option v-for="(item, index) in centerList" :key="item.id" :value="item.id">{{ item.name
          }}</a-select-option>
        </a-select>
      </div>
    </a-modal>
    <a-modal v-model:open="timeFlag" title="指定时间" @ok="handleTimeRange()" @cancel="handleCancelTimeRange">
      <div>
        <div class="select-title">指定时间</div>
        <a-range-picker valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" dropdownClassName="select-center-time"
          class="picker" v-model:value="timeRange" style="width: 100%;" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import { CACHE_PROJECT_ID } from '@/constants/project'
import { Row, Col, Card } from 'ant-design-vue'
import lineImg from '@/assets/cockpit/line.png'
import { getAction, postAction, downloadFile } from '@/api/manage'
import Vue from 'vue'
export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Card.name]: Card
  },
  data() {
    return {
      lastRefreshTime: '',
      centerId: null,
      tempCenterId: null,
      modalFlag: false,
      timeFlag: false,
      timeRange: [],
      period1: 1,
      period2: 10,
      period3: 1,
      period4: 1,
      period5: 31,
      charts: {},
      groupCount: {},
      centerGroupCount: {},
      projectId: Vue.ls.get(CACHE_PROJECT_ID) || '',
      // 模拟数据
      dateRange: ['2024-07', '2024-08', '2024-09', '2024-10', '2024-11', '2024-12', '2025-01', '2025-02', '2025-03', '2025-04', '2025-05', '2025-06'],
      centerList: [],
      selectCenterItem: {}
    }
  },
  async mounted() {
    this.projectId = Vue.ls.get(CACHE_PROJECT_ID)
    console.log(this.projectId)
    // 获取中心列表
    await getAction('/project/center/auth_center', { projectId: this.projectId }).then(res => {
      if (res.success && res.result) {
        this.centerList = res.result
        this.handleOk(this.centerList[0].id)
      } else {
        this.$message.error('后台请求异常')
      }
    })
    this.initCharts()
    window.addEventListener('resize', this.handleResize)
    // 更新刷新时间
    this.updateRefreshTime()

    // 监听 A 窗口发送的消息
    window.addEventListener('message', this.handleAMessage)
    // 监听窗口关闭事件
    window.addEventListener('beforeunload', this.watchBWindowClose)
  },
  // beforeUnmount() {
  //   window.removeEventListener('message', this.handleAMessage)
  // },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    Object.values(this.charts).forEach(chart => chart.dispose())
    window.removeEventListener('beforeunload', this.watchBWindowClose)
  },
  methods: {
    watchBWindowClose() {
      // 设置isBOpen为false
      window.localStorage.removeItem('isBOpen')
    },
    updateRefreshTime() {
      this.lastRefreshTime = new Date().toLocaleString()
    },
    // 处理 A 窗口的消息
    handleAMessage(event) {
      // 验证消息来源（可选，增强安全性）
      if (event.data === 'A_CLOSED') {
        this.status = 'A 窗口已关闭，即将关闭...';
        // 1秒后自动关闭
        setTimeout(() => {
          window.close()
        }, 1000)
      }
    },
    handleModalFlag() {
      this.modalFlag = !this.modalFlag
    },
    handleTimeRange() {
      if (this.timeRange.length === 2) {
        this.period4 = 0
        this.timeFlag = false
        this.initVisitorCountChart(this.timeRange)
      } else {
        this.$message.error('请选择时间范围')
      }
    },
    handleCancelTimeRange() {
      this.timeFlag = false
    },
    handleOk(id) {
      this.modalFlag = false
      this.tempCenterId = id
      this.centerId = id
      const findItem = this.centerList.find(item => item.id === id)
      if (findItem) {
        this.selectCenterItem = findItem
      }
      this.entryCountStatistics(this.centerId)
      // 受试者性别分布
      this.initGenderChart()
      // 受试者年龄分布
      this.initAgeChart()
      // 总应答率
      this.initSuccessRateChart()
      // 随访率
      this.initErrorRateChart()
      // 调查员入组人数分布
      this.initVisitorDistChart()
      // 调查员平均入组人数趋势
      this.initAvgVisitorChart()
      // 调查员随访人次
      this.initVisitorCountChart()
    },
    handlePeriod(type, item) {
      switch (type) {
        case 1:
          this.period1 = item.value
          this.initVisitorDistChart()
          break;
        case 2:
          this.period2 = item.value
          this.initSuccessRateChart()
          break;
        case 3:
          this.period3 = item.value
          this.initAvgVisitorChart()
          break;
        case 4:
          if (item.value === 0) {
            this.timeFlag = true
          } else {
            this.period4 = item.value
            this.initVisitorCountChart()
          }
          break;
        case 5:
          this.period5 = item.value
          this.initTrendChart()
          break;
      }
    },
    initDateRange(type) {
      let dateRange = []
      switch (type) {
        case 1:
          dateRange = [
            {
              name: "当周",
              value: 1,
            },
            {
              name: "当月",
              value: 2,
            },
            {
              name: "当年",
              value: 3,
            }
          ]
          break;
        case 2:
          dateRange = [
            {
              name: "周",
              value: 10
            },
            {
              name: "月",
              value: 11
            }
          ]
          break;
        case 3:
          dateRange = [
            {
              name: "周",
              value: 1,
            },
            {
              name: "月",
              value: 2,
            },
            {
              name: "季度",
              value: 3,
            },
            {
              name: "年",
              value: 4,
            }
          ]
          break;
        case 4:
          dateRange = [
            {
              name: "周",
              value: 1,
            },
            {
              name: "月",
              value: 2,
            },
            {
              name: "指定时间",
              type: "time",
              value: 0,
            },
          ]
          break;
        case 5:
          dateRange = [
            {
              name: "周",
              value: 31,
            },
            {
              name: "月",
              value: 3,
            },
            {
              name: "季度",
              value: 32,
            },
            {
              name: "年",
              value: 33,
            },
          ]
      }
      return dateRange
    },
    initCharts() {
      // 初始化echart#d
      this.setBarChart3D(24, 'CubeLeft24', 'CubeRight24', 'CubeTop24')
      // 入组人数统计
      this.entryCountStatistics()
      // 中心入组人数趋势图
      this.initPassGroupTrendChart()
      // 中心入组趋势图
      this.initTrendChart()
      // 中心应答率/随访率统计
      this.initRateChart()
    },
    // 绘制3s柱状体
    async setBarChart3D(offsetX = 24, nameLeft, nameRight, nameTop, offsetY = 8) {
      // 绘制左侧面
      const CubeLeft = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          // 会canvas的应该都能看得懂，shape是从custom传入的
          const xAxisPoint = shape.xAxisPoint
          // console.log(shape);
          const c0 = [shape.x, shape.y]
          const c1 = [shape.x - offsetX, shape.y - offsetY]
          const c2 = [xAxisPoint[0] - offsetX, xAxisPoint[1] - offsetY]
          const c3 = [xAxisPoint[0], xAxisPoint[1]]
          ctx.moveTo(c0[0], c0[1]).lineTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).closePath()
        }
      })
      // 绘制右侧面
      const CubeRight = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint
          const c1 = [shape.x, shape.y]
          const c2 = [xAxisPoint[0], xAxisPoint[1]]
          const c3 = [xAxisPoint[0] + offsetX, xAxisPoint[1] - offsetY]
          const c4 = [shape.x + offsetX, shape.y - offsetY]
          ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath()
        }
      })
      // 绘制顶面
      const CubeTop = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y]
          const c2 = [shape.x + offsetX, shape.y - offsetY] //右点
          // const c3 = [shape.x, shape.y - offsetX];
          const c3 = [shape.x, shape.y - offsetY * 2]
          const c4 = [shape.x - offsetX, shape.y - offsetY]
          ctx.moveTo(c1[0], c1[1]).lineTo(c2[0], c2[1]).lineTo(c3[0], c3[1]).lineTo(c4[0], c4[1]).closePath();
        }
      })
      // 注册三个面图形
      echarts.graphic.registerShape(nameLeft, CubeLeft)
      echarts.graphic.registerShape(nameRight, CubeRight)
      echarts.graphic.registerShape(nameTop, CubeTop)
      return { CubeLeft, CubeRight, CubeTop }
    },
    // 入组人数统计
    async entryCountStatistics(centerId) {
      const params = {
        projectId: this.projectId,
        centerId: centerId || null,
        row: 1
      }
      const res = await getAction('/management/project/getViewInfo', params)
      if (res.success) {
        if (centerId) {
          this.centerGroupCount = res.result
        } else {
          this.groupCount = res.result
        }
      }
    },
    async initPassGroupTrendChart() {
      const res = await getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 2 })
      let data = []
      if (res.success) {
        data = res.result.pass_group_center
      }
      const chart = echarts.init(this.$refs.centralGroupChart)
      this.charts.centralGroupChart = chart
      let colorArr = [["#7099fa"], ["#204cc3", "rgba(19, 62, 178,1)"], ["#204cc3", "rgba(19, 62, 178,1)"]]
      let option = {
        // backgroundColor: '#0c2d55',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[0].color};"></span> ${params[0].name}</span><span class="tip-value">${params[0].value}</span></div>
              </div>
            <div>
            `
          }
        },
        grid: {
          left: '1%',
          right: '0',
          top: '20',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.map(item => item.centerName),
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 14,
            color: "#fff",
            fontFamily: 'siyuan',
            margin: 15,
            opacity: 0.5
          }
        },
        yAxis: {
          type: 'value',
          min: 0,
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "#fff",
            opacity: 0.5,
            fontSize: 14,
          },
          boundaryGap: ['20%', '20%'],
        },
        series: [
          {
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: 'group',
                y: 11,
                children: [
                  {
                    type: 'CubeLeft24',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight24',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop24',
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[0][0],
                        },
                      ]),
                    },
                  },
                ],
              };
            },
            data: data.map(item => item.count)
          },
          {
            type: 'bar',
            label: {
              normal: {
                show: false,
                position: 'top',
                formatter: (e) => {
                  // return e.value + '次';
                  return e.value;
                },
                fontSize: 24,
                color: "#fff",
                fontFamily: 'siyuan',
                fontWeight: 'bold',
                offset: [0, -15],
              },
            },
            itemStyle: {
              color: 'transparent'
            },
            tooltip: {},
            data: data.map(item => item.count)
          }
        ]
      }
      chart.setOption(option)
    },

    // 中心入组趋势图
    async initTrendChart() {
      const res = await getAction('/management/project/getViewInfo', { projectId: this.projectId, row: this.period5 })
      let data = {}
      if (res.success) {
        data = res.result.pass_group_center_month
      }
      const chart = echarts.init(this.$refs.trendChart)
      this.charts.trendChart = chart

      // 方法1：转换为扁平数组
      const groupedData = Object.entries(data).map(([hospital, data]) => ({
        hospital,
        data,
      }))
      console.log(groupedData)
      let baseColors = ['#0A84FF', '#00CEEA', '#F7BA1E']
      let colorList = this.assignRandomColorsToArray(groupedData, baseColors)
      let areaColorList = this.generateUniqueAreaColors(groupedData, baseColors)
      const option = {
        grid: {
          left: '5%',
          right: '0',
          top: '10%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div>${params[0].name}</div>
                ${params.map(item => `
                 <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${item.color};"></span> ${item.seriesName}</span><span class="tip-value">${item.value}</span></div>
                `).join('')}
              </div>
            <div>
            `
          }
        },
        color: colorList,
        legend: {
          top: '0',
          left: '80',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          }
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#94A7BD'//轴线和单位颜色
              }
            },
            data: groupedData[0].data.map(item => item.month)
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位(人)',
            nameTextStyle: {
              fontSize: 14,
              color: '#94A7BD',
              padding: [0, 0, 0, -30],
            },
            axisLine: {
              lineStyle: {
                color: '#94A7BD'//轴线和单位颜色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182D46',
                type: [2, 3],
                dashOffset: 2
              }
            },
          },
        ],
        series: groupedData.map((item, index) => {
          return {
            name: item.hospital,
            type: 'line',
            smooth: true,
            symbol: 'none',
            symbolSize: 8,
            zlevel: 3,
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: areaColorList[index].from,
                  },
                  {
                    offset: 1,
                    color: areaColorList[index].to,
                  },
                ],
                global: false,
              },
            },
            data: item.data.map(flat => flat.count)
          }
        })
      }

      chart.setOption(option)
    },
    calculateBaseOffsetSegmented(arrayLength) {
      if (arrayLength <= 3) {
        return {
          x: 24,
          y: 8
        } // 数组很短时用最大offset
      } else if (arrayLength <= 10) {
        return {
          x: 12,
          y: 4
        } // 中等长度
      } else if (arrayLength <= 20) {
        return {
          x: 6,
          y: 2
        } // 较长数组
      } else {
        return {
          x: 6,
          y: 2
        } // 较长数组
      }
    },
    // 中心应答率/随访率统计
    async initRateChart() {
      const res = await getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 4 })
      let data = {}
      if (res.success) {
        data = res.result.center_form_rate
      }
      const chart = echarts.init(this.$refs.rateChart)
      this.charts.rateChart = chart
      let colorList = ['#4069d4', '#3cc5e7', '#204cc3']
      let colorArr = [["#7099fa"], ["#204cc3", "rgba(19, 62, 178,1)"], ["#204cc3", "rgba(19, 62, 178,1)"]]
      let colorArr2 = [["#07afcb"], ["#07afcb", "rgba(51, 174, 222,1)"], ["#07afcb", "rgba(51, 174, 222,1)"]]
      const baseOffest = this.calculateBaseOffsetSegmented(data.length).x
      const offestY = this.calculateBaseOffsetSegmented(data.length).y
      this.setBarChart3D(baseOffest, 'CubeLeft' + baseOffest, 'CubeRight' + baseOffest, 'CubeTop' + baseOffest, offestY)
      // 主体
      let option = {
        legend: {
          top: '1%',
          right: '5%',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div>${params[0].name}</div>
                ${params.map(item => `
                 <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${item.color};"></span> ${item.seriesName}</span><span class="tip-value">${item.value}%</span></div>
                `).join('')}
              </div>
            <div>
            `
          }
        },
        color: colorList,
        grid: {
          left: '1%',
          right: '1%',
          top: '8%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.map(item => item.centerName),
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 14,
            color: "#fff",
            fontFamily: 'siyuan',
            margin: 15,
            opacity: 0.5
          }
        },
        yAxis: {
          type: 'value',
          min: '0', // 最小值
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#94a3b8',
            formatter: '{value}%'
          },
          boundaryGap: ['20%', '20%'],
        },
        series: [
          // 柱体
          {
            name: '应答率',
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: 'group',
                x: -baseOffest,
                y: offestY + 3,
                children: [
                  {
                    type: 'CubeLeft' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[0][0],
                        },
                      ]),
                    },
                  },
                ]
              }
            },
            data: data.map(item => item.resRate)
          },
          // 柱体
          {
            name: '随访率',
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: 'group',
                x: baseOffest,
                y: offestY + 3,
                children: [
                  {
                    type: 'CubeLeft' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[0][0],
                        },
                      ]),
                    },
                  },
                ],
              };
            },
            data: data.map(item => item.floRate)
          },
        ],
      }

      chart.setOption(option)
    },

    // 受试者性别分布
    async initGenderChart() {
      const res = await getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 5, centerId: this.centerId })
      let data = {}
      if (res.success) {
        data = res.result.pass_sex_center
      }
      let sum = 0
      data.forEach(item => {
        sum += Number(item.count || 0)
      })
      let optionData = []
      data.forEach(item => {
        optionData.push({ value: item.count, name: item.centerName });
        // 配置一个空值
        optionData.push({ name: '', value: sum / 100, itemStyle: { color: 'transparent' } });
      })
      const chart = echarts.init(this.$refs.genderChart)
      this.charts.genderChart = chart
      // 颜色值配置一个空，用于显示间距
      const colorList1 = ['#018CFF', '', '#FCAF03', '', '#1DBB67', '', '#FF586C', ''];
      const colorList2 = ['rgba(1,140,255, 0.4)', '', 'rgba(252,175,3, 0.4)', '', 'rgba(29,187,103, 0.4)', '', 'rgba(255,88,108, 0.4)', '']
      var option = {
        tooltip: {
          trigger: 'item',
          show: true,
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params.color};"></span> ${params.name}</span><span class="tip-value">${params.value}</span></div>
              </div>
            <div>
            `
          }
        },
        legend: {
          bottom: 'bottom',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          },
          data: data.map(item => item.centerName)
        },
        grid: {
          left: '1%',
          right: '1%',
          top: '1%',
          bottom: '10%',
          containLabel: true
        },
        title: {
          text: '{b|总数}\n{a|' + sum + '}',
          left: '50%',
          top: 'center',
          itemGap: 10,
          textStyle: {
            rich: {
              b: {
                color: '#a7d2e9',
                fontSize: 14,
                padding: 10
              },
              a: {
                color: '#a7d2e9',
                fontSize: 32,
                fontWeight: 700

              }
            },
          },
          textAlign: 'center'
        },

        series: [
          {
            // 饼图圈
            type: 'pie',
            zlevel: 3,
            radius: ['35%', '45%'],
            itemStyle: {
              normal: {
                //  borderColor: '#0A1934',
                // borderWidth:5,
                color: function (params) {
                  return colorList2[params.dataIndex]
                }
              }
            },
            label: {
              show: false,
            },
            data: optionData,
          },
          {
            // 最外圆圈
            type: 'pie',
            zlevel: 1,
            silent: true, //取消高亮
            radius: ['48%', '50%'],
            itemStyle: {
              normal: {
                //  borderColor: '#0A1934',
                // borderWidth:5,
                color: function (params) {
                  return colorList1[params.dataIndex]
                }
              }
            },
            label: {
              show: false
            },
            data: optionData,
          },
        ]
      };

      chart.setOption(option)
    },

    // 受试者年龄分布
    async initAgeChart() {
      const res = await getAction('/management/project/getViewInfo', { projectId: this.projectId, row: 6, centerId: this.centerId })
      let data = {}
      if (res.success) {
        data = res.result.pass_age_center
      }
      let sum = 0
      data.forEach(item => {
        sum += Number(item.count || 0)
      })
      let optionData = []
      data.forEach(item => {
        optionData.push({ value: item.count, name: item.centerName })
        // 配置一个空值
        optionData.push({ name: '', value: sum / 100, itemStyle: { color: 'transparent' } })
      })
      const chart = echarts.init(this.$refs.ageChart)
      this.charts.ageChart = chart
      const colorList1 = ['#018CFF', '', '#FCAF03', '', '#1DBB67', '', '#FF586C', ''];
      const colorList2 = ['rgba(1,140,255, 0.4)', '', 'rgba(252,175,3, 0.4)', '', 'rgba(29,187,103, 0.4)', '', 'rgba(255,88,108, 0.4)', '']
      const option = {
        title: {
          text: '{b|总数}\n{a|' + sum + '}',
          left: '50%',
          top: 'center',
          itemGap: 10,
          textStyle: {
            rich: {
              b: {
                color: '#a7d2e9',
                fontSize: 14,
                padding: 10
              },
              a: {
                color: '#a7d2e9',
                fontSize: 32,
                fontWeight: 700

              }
            },
          },
          textAlign: 'center',
        },
        tooltip: {
          trigger: 'item',
          show: true,
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params.color};"></span> ${params.name}</span><span class="tip-value">${params.value}</span></div>
              </div>
            <div>
            `
          }
        },
        legend: {
          bottom: 'bottom',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          },
          data: data.map(item => item.centerName)
        },
        series: [
          {
            // 饼图圈
            type: 'pie',
            zlevel: 3,
            radius: ['35%', '45%'],
            itemStyle: {
              normal: {
                //  borderColor: '#0A1934',
                // borderWidth:5,
                color: function (params) {
                  return colorList2[params.dataIndex]
                }
              }
            },
            label: {
              show: false,
            },
            data: optionData,
          },
          {
            // 最外圆圈
            type: 'pie',
            zlevel: 1,
            silent: true, //取消高亮
            radius: ['48%', '50%'],
            itemStyle: {
              normal: {
                //  borderColor: '#0A1934',
                // borderWidth:5,
                color: function (params) {
                  return colorList1[params.dataIndex]
                }
              }
            },
            label: {
              show: false
            },
            data: optionData,
          },
        ]
      }

      chart.setOption(option)
    },

    // 总应答率
    async initSuccessRateChart() {
      const res = await getAction('/management/project/getViewInfo', { projectId: this.projectId, row: this.period2, centerId: this.centerId })
      let data = {}
      if (res.success) {
        data = res.result.patient_rate
      }
      const chart = echarts.init(this.$refs.successRateChart)
      this.charts.successRateChart = chart

      const option = {
        backgroundColor: '#111f3a',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div class="tip-title">应答率</div>
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[0].color};"></span> ${params[0].name}</span><span class="tip-value">${params[0].value}%</span></div>
              </div>
            <div>
            `
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.map(item => item.name),
          axisLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.3)' } },
          axisLabel: { color: '#94a3b8' }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.3)' } },
          splitLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.1)' } },
          axisLabel: {
            color: '#94a3b8',
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '应答率',
            type: 'line',
            // stack: 'Total',
            data: data.map(item => item.resRate),
            smooth: true,
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#1a83ee' },
                { offset: 1, color: '#1a83ee' }
              ])
            },
            itemStyle: { color: '#0ea5e9', size: 8 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(12, 131, 252, 0.3)' },
                { offset: 1, color: 'rgba(12, 131, 252, 0)' }
              ])
            }
          }
        ]
      }

      chart.setOption(option)
    },

    // 随访率
    async initErrorRateChart() {
      const res = await getAction('/management/index/report/visitRate', { projectId: this.projectId, centerId: this.centerId })
      let data = []
      if (res.success) {
        data = res.result
      }
      const chart = echarts.init(this.$refs.errorRateChart)
      this.charts.errorRateChart = chart
      const option = {
        // backgroundColor: '#111f3a',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[0].color};"></span> ${params[0].name}</span><span class="tip-value">${params[0].value}%</span></div>
              </div>
            <div>
            `
          }
        },
        grid: {
          left: '1%',
          right: '5%',
          top: '8%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.map(item => item.name),
          axisLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.3)' } },
          axisLabel: { color: '#94a3b8' }
        },
        yAxis: {
          type: 'value',
          max: 100,
          axisLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.3)' } },
          splitLine: { lineStyle: { color: 'rgba(148, 163, 184, 0.1)' } },
          axisLabel: {
            color: '#94a3b8',
            formatter: '{value}%'
          }
        },
        series: [
          {
            name: '随访率',
            type: 'line',
            // stack: 'Total',
            data: data.map(item => item.submitCountRate),
            smooth: true,
            lineStyle: {
              width: 3,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                { offset: 0, color: '#1a83ee' },
                { offset: 1, color: '#1a83ee' }
              ])
            },
            itemStyle: { color: '#0ea5e9', size: 8 },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(12, 131, 252, 0.3)' },
                { offset: 1, color: 'rgba(12, 131, 252, 0)' }
              ])
            }
          }
        ]
      }
      chart.setOption(option)
    },

    // 调查员入组人数分布
    async initVisitorDistChart() {
      const res = await getAction('/management/index/report/registPatient', { projectId: this.projectId, centerId: this.centerId, period: this.period1 })
      let data = []
      if (res.success) {
        data = res.result
      }
      const chart = echarts.init(this.$refs.visitorDistChart)
      this.charts.visitorDistChart = chart
      let colorList = ['#4069d4', '#3cc5e7', '#204cc3']
      let colorArr = [["#7099fa"], ["#204cc3", "rgba(19, 62, 178,1)"], ["#204cc3", "rgba(19, 62, 178,1)"]]
      let colorArr2 = [["#07afcb"], ["#07afcb", "rgba(51, 174, 222,1)"], ["#07afcb", "rgba(51, 174, 222,1)"]]
      const baseOffest = this.calculateBaseOffsetSegmented(data.length).x
      const offestY = this.calculateBaseOffsetSegmented(data.length).y
      this.setBarChart3D(baseOffest, 'CubeLeft' + baseOffest, 'CubeRight' + baseOffest, 'CubeTop' + baseOffest, offestY)
      // 主体
      let option = {
        legend: {
          top: '1%',
          right: '0',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            snap: true // 自动吸附到数据点
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
               <div class="tip-content">
                <div>${params[0].name}</div>
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[0].color};"></span> ${params[0].seriesName}</span><span class="tip-value">${params[0].value}</span></div>
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[1].color};"></span> ${params[1].seriesName}</span><span class="tip-value">${params[1].value}</span></div>
              </div>
            <div>
            `
          }
        },
        color: colorList,
        // dataZoom: [
        //   {
        //     type: 'inside', // 内置型数据区域缩放
        //     start: 0,
        //     end: 100
        //   },
        //   {
        //     type: 'slider', // 滑动条型数据区域缩放
        //     start: 0,
        //     end: 100
        //   }
        // ],
        grid: {
          left: '1%',
          right: '1%',
          top: '8%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.map(item => item.personName),
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 14,
            color: "#fff",
            fontFamily: 'siyuan',
            margin: 15,
            opacity: 0.5
          }
        },
        yAxis: {
          type: 'value',
          min: '0', // 最小值
          name: '单位(人)',
          nameTextStyle: {
            fontSize: 14,
            color: '#94A7BD',
            padding: [0, 0, 0, 0]
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "#fff",
            opacity: 0.5,
            fontSize: 14,
          },
          boundaryGap: ['20%', '20%'],
        },
        series: [
          // 柱体
          {
            // 提高数据点采样精度
            sampling: 'none',
            name: '注册人数',
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: 'group',
                x: -baseOffest,
                children: [
                  {
                    type: 'CubeLeft' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[0][0],
                        },
                      ]),
                    },
                  },
                ],
              };
            },
            data: data.map((d) => d.registerCount)
          },
          // 柱体
          {
            name: '入组人数',
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: 'group',
                x: baseOffest,
                children: [
                  {
                    type: 'CubeLeft' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[0][0],
                        }
                      ])
                    }
                  }
                ]
              }
            },
            data: data.map((d) => d.groupCount)
          }
        ]
      }
      chart.setOption(option)
    },
    assignRandomColorsToArray(array, baseColors = []) {
      return array.map((item, index) => {
        // 前几个元素使用baseColors中的颜色
        if (index < baseColors.length) {
          return baseColors[index];
        }

        // 为剩余元素生成不同的随机颜色
        const usedColors = new Set(baseColors);
        let randomColor;

        do {
          // 生成随机颜色（这里使用16进制颜色代码格式）
          randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
        } while (usedColors.has(randomColor));

        usedColors.add(randomColor);
        return randomColor;
      });
    },
    generateUniqueAreaColors(array, baseColors) {
      const usedColors = new Set();

      return array.map((_, index) => {
        let baseColor;

        // 前几个元素使用baseColors中的颜色
        if (index < baseColors.length) {
          baseColor = baseColors[index];
        } else {
          // 为剩余元素生成不同的随机颜色
          do {
            baseColor = '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
          } while (usedColors.has(baseColor));
        }

        usedColors.add(baseColor);

        const hex = baseColor.replace('#', '');
        const r = parseInt(hex.substr(0, 2), 16);
        const g = parseInt(hex.substr(2, 2), 16);
        const b = parseInt(hex.substr(4, 2), 16);

        return {
          to: `rgba(${r}, ${g}, ${b}, 0)`,
          from: `rgba(${r}, ${g}, ${b}, 0.2)`
        }
      })
    },
    // 调查员平均入组人数趋势
    async initAvgVisitorChart() {
      const res = await getAction('/management/index/report/average/join/patient', { projectId: this.projectId, centerId: this.centerId, period: this.period3 })
      let data = []
      let seriesData = []
      if (res.success) {
        data = res.result
        // 获取所有人员
        const persons = [...new Set(Object.values(res.result).flat().map(item => item.personName))]

        // 生成ECharts数据系列
        seriesData = persons.map((person, index) => {
          return {
            name: person,
            data: Object.values(res.result).map(quarter => {
              const personData = quarter.find(item => item.personName === person)
              return personData ? personData.averageCount : 0
            })
          }
        })
      }
      const chart = echarts.init(this.$refs.avgVisitorChart)
      this.charts.avgVisitorChart = chart
      // 随机生成颜色
      let baseColors = ['#0A84FF', '#00CEEA', '#F7BA1E']
      let colorList = this.assignRandomColorsToArray(seriesData, baseColors)
      let areaColorList = this.generateUniqueAreaColors(seriesData, baseColors)

      const option = {
        grid: {
          left: '0',
          right: '1%',
          top: '8%',
          bottom: '1%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div>${params[0].name}</div>
                  ${params.map(item => `
                 <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${item.color};"></span> ${item.seriesName}</span><span class="tip-value">${item.value.toFixed(0)}</span></div>
                `).join('')}
              </div>
            <div>
            `
          }
        },
        color: colorList,
        legend: {
          top: '0',
          left: '50',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          },
          data: seriesData.map(item => item.name).slice(0, 15)
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: true,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#94A7BD'//轴线和单位颜色
              }
            },
            data: Object.keys(data)
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单位(人)',
            nameTextStyle: {
              fontSize: 14,
              color: '#94A7BD',
              padding: [0, 0, 0, 20]
            },
            axisLine: {
              lineStyle: {
                color: '#94A7BD'//轴线和单位颜色
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#182D46',
                type: [2, 3],
                dashOffset: 2
              }
            },
          },
        ],
        series: seriesData.map((item, index) => {
          return {
            name: item.name,
            type: 'line',
            smooth: true,
            symbol: 'none',
            symbolSize: 8,
            zlevel: 3,
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: areaColorList[index].from,
                  },
                  {
                    offset: 1,
                    color: areaColorList[index].to,
                  },
                ],
                global: false,
              },
            },
            data: item.data
          }
        })
      }

      chart.setOption(option)
    },

    // 调查员随访人次
    async initVisitorCountChart(timeRange) {
      const params = {
        projectId: this.projectId,
        centerId: this.centerId,
        period: this.period4,
        startDate: timeRange ? timeRange[0] : null,
        endDate: timeRange ? timeRange[1] : null
      }
      const res = await getAction('/management/index/report/visitPatient', params)
      let data = []
      if (res.success) {
        data = res.result
      }
      const chart = echarts.init(this.$refs.visitorCountChart)
      this.charts.visitorCountChart = chart
      let colorList = ['#4069d4', '#3cc5e7', '#204cc3']
      let colorArr = [["#7099fa"], ["#204cc3", "rgba(19, 62, 178,1)"], ["#204cc3", "rgba(19, 62, 178,1)"]]
      let colorArr2 = [["#07afcb"], ["#07afcb", "rgba(51, 174, 222,1)"], ["#07afcb", "rgba(51, 174, 222,1)"]]
      const baseOffest = this.calculateBaseOffsetSegmented(data.length).x
      const offestY = this.calculateBaseOffsetSegmented(data.length).y
      this.setBarChart3D(baseOffest, 'CubeLeft' + baseOffest, 'CubeRight' + baseOffest, 'CubeTop' + baseOffest, offestY)
      // 主体
      let option = {
        legend: {
          top: '1%',
          right: '0',
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            color: '#94A7BD'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          backgroundColor: '#17294a',
          padding: [2, 2, 2, 2],
          borderRadius: 0,
          borderColor: '#1468ad',
          textStyle: { color: '#fff' },
          formatter: function (params) {
            return `
            <div class="tooltip-box">
              <div class="tip-b-t"></div>
              <div class="tip-b-b"></div>
              <div class="tip-b-l"></div>
              <div class="tip-b-r"></div>
              <div class="tip-content">
                <div>${params[0].name}</div>
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[0].color};"></span> ${params[0].seriesName}</span><span class="tip-value">${params[0].value.toFixed(2)}</span></div>
                <div class="tip-title"><span class="tip-name"><span class="tip-tag" style="background-color: ${params[1].color};"></span> ${params[1].seriesName}</span><span class="tip-value">${params[1].value.toFixed(2)}</span></div>
              </div>
            <div>
            `
          }
        },
        color: colorList,
        grid: {
          left: '0',
          right: '1%',
          top: '8%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.map(item => item.personName),
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            fontSize: 14,
            color: "#fff",
            fontFamily: 'siyuan',
            margin: 15,
            opacity: 0.5
          }
        },
        yAxis: {
          type: 'value',
          min: '0', // 最小值
          name: '单位(人)',
          nameTextStyle: {
            fontSize: 14,
            color: '#94A7BD',
            padding: [0, 0, 0, 0]
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#1e293e',
              opacity: 0.5,
              type: 'dashed'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            show: true,
            color: "#fff",
            opacity: 0.5,
            fontSize: 14,
          },
          boundaryGap: ['20%', '20%'],
        },
        series: [
          // 柱体
          {
            name: '总随访人次',
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)])
              return {
                type: 'group',
                x: -baseOffest,
                children: [
                  {
                    type: 'CubeLeft' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr[0][0],
                        },
                      ]),
                    },
                  },
                ],
              }
            },
            data: data.map((item) => item.totalCount)
          },
          // 柱体
          {
            name: '日平均随访人次',
            type: 'custom',
            renderItem: (params, api) => {
              const location = api.coord([api.value(0), api.value(1)]);
              return {
                type: 'group',
                x: baseOffest,
                children: [
                  {
                    type: 'CubeLeft' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[1][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[1][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeRight' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[2][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[2][1],
                        },
                      ]),
                    },
                  },
                  {
                    type: 'CubeTop' + baseOffest,
                    shape: {
                      api,
                      xValue: api.value(0),
                      yValue: api.value(1),
                      x: location[0],
                      y: location[1],
                      xAxisPoint: api.coord([api.value(0), 0]),
                    },
                    style: {
                      fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        {
                          offset: 0,
                          color: colorArr2[0][0],
                        },
                        {
                          offset: 1,
                          color: colorArr2[0][0],
                        },
                      ]),
                    },
                  },
                ],
              };
            },
            data: data.map((item) => item.average)
          }
        ]
      }
      chart.setOption(option)
    },

    handleResize() {
      setTimeout(() => {
        Object.values(this.charts).forEach(chart => chart.resize())
      }, 300)
    }
  }
}
</script>

<style scoped lang="less">
.screen-container {
  width: 100%;
  min-height: 100vh;
  // padding: 20px;
  background-image:
    radial-gradient(circle at 10% 20%, rgba(15, 46, 96, 0.3) 0%, transparent 20%),
    radial-gradient(circle at 90% 80%, rgba(15, 46, 96, 0.3) 0%, transparent 20%);
  color: #fff;
  box-sizing: border-box;
  position: relative;
  // overflow: hidden;
  /* overflow: hidden; */
  // background: radial-gradient( 73% 73% at 46% 0%, #304C7E 0%, rgba(48,76,126,0) 100%);
  // background: #040e1e;
  background: #091428;
}

.header {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;

  .r-t {
    position: absolute;
    // height: 90px;
    width: 224px;
    top: 0;
    right: 0;
  }

  .l-t {
    position: absolute;
    // height: 90px;
    width: 224px;
    top: 0;
    left: 0;
    // transform: translateX(-50%);
  }

  .l-d {
    position: absolute;
    top: 156px;
    right: 0;
    max-height: 720px;
  }

  .r-d {
    position: absolute;
    top: 156px;
    left: 0;
    max-height: 720px;
  }

  .back {
    position: relative;
    // width: 100%;
    top: -50px;

    .t-b-b {
      position: absolute;
      height: 100px;
      // width: 100%;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2;
    }

    .t-b-r {
      position: absolute;
      height: 90px;
      top: 0;
      left: 50%;
      // transform: translateX(-50%);
    }

    .t-b-l {
      position: absolute;
      height: 90px;
      top: 0;
      right: 50%;
      // transform: translateX(-50%);
    }
  }

  h1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 44px;
    color: #F8FCFF;
    letter-spacing: 2px;
    text-shadow: inset 0px 0px 2px #FFFFFF, 0px 0px 18px rgba(34, 96, 255, 0.5), 0px 4px 1px rgba(19, 80, 143, 0.66);
    text-align: left;
    font-style: normal;
    text-transform: none;
    // background: linear-gradient(89.99999999999987deg, #FFFFFF 0%, #77BAFF 100%);
    z-index: 999;
    margin-bottom: 40px;
    position: absolute;
  }
}

.footer-back {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .b-d {
    width: 100%;
    max-width: 1600px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
  }

  .l-b {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 244px;
  }

  .r-b {
    position: absolute;
    bottom: 0;
    right: 0;
    width: 244px;
  }
}

.main-content {
  height: calc(92% - 20px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0 54px 100px 54px;

  .c-title {
    position: relative;

    .t-b {
      width: 500px;
      height: 63px;
    }

    .t-text {
      position: relative;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 32px;
      color: #F6F9FE;
      text-shadow: 0px 0px 7px rgba(75, 180, 229, 0.25), 0px 2px 8px rgba(5, 28, 55, 0.42);
      text-align: left;
      font-style: normal;
      text-transform: none;
      //background: linear-gradient(90deg, #31BEFF 2%, rgba(255, 255, 255, 0) 62%);
      text-transform: none;
      position: absolute;
      left: 49px;
      bottom: 30px;
      transform: skew(-15deg);
    }

    .center {
      position: absolute;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #C8D9FF;
      line-height: 22px;
      right: -100px;
      bottom: 14px;
      white-space: nowrap;
      transform: skew(0);
      cursor: pointer;

      img {
        width: 16px;
      }
    }
  }
}

.row {
  display: flex;
  gap: 20px;
  height: calc(25% - 15px);
  min-height: 380px;
  /* 四行平均分配高度，减去间距 */
  position: relative;
}

.row-3 {
  background-color: #101e38;
}

// .row-1,
// .row-3,
// .row-4 {
//   height: 22%;
// }

// .row-2 {
//   height: 34%;
// }

.card {
  // background: rgba(10, 30, 60, 0.7);
  // border: 1px solid rgba(14, 165, 233, 0.3);
  // border-radius: 8px;
  // padding: 15px;
  // box-shadow: 0 0 15px rgba(14, 165, 233, 0.1);
  // backdrop-filter: blur(5px);
  // display: flex;
  // flex-direction: column;
  position: relative;

  .searchtime {
    position: absolute;
    display: flex;
    align-items: center;
    right: 0;
    top: 0;
    gap: 16px;

    .item {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #7FCFF4;
      line-height: 22px;
      white-space: nowrap;
      cursor: pointer;
      padding: 3px 6px;
      border: 1px solid #004EA2;
      border-radius: 5px 5px 5px 5px;
    }

    .active {
      background: #003B7A;
      border-radius: 5px 5px 5px 5px;
      border: 1px solid #004EA2;
      padding: 3px 6px;
    }
  }
}

.card-title {
  position: relative;
  padding: 3px;
  padding-right: 30px;
  max-width: 50%;
  background: linear-gradient(90deg, #1B315F 0%, rgba(27, 49, 95, 0) 100%);
  border-radius: 0px 0px 0px 0px;
  border: 1px solid;
  // margin-bottom: 10px;
  border-right: none;
  // border-right: 1px solid rgba(82, 82, 82, 0.9);
  border-left: none;
  padding-left: 8px;
  white-space: nowrap;
  border-image: linear-gradient(45deg, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.01)) 1 1;
}

.card-title::after {
  content: "";
  width: 3px;
  height: 100%;
  position: absolute;
  left: 0;
  background: #0ea5e9;
  top: 0;
}

.chart-placeholder {
  width: 100%;
  // height: calc(100% - 30px);
  height: 100%;
  max-height: 550px;
  // background-color: rgba(15, 46, 96, 0.2);
  border-radius: 4px;
}

/* 第一行卡片布局 */
.overview-card,
.trend-card,
.rate-card {
  width: calc(100% / 3);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.back-root {
  position: absolute;
  width: 100%;
  // left: 50%;
  // transform: translateX(-50%);
  height: 10%;
  background-color: #051127;
  background-image:
    /* 中心轻微提亮的径向渐变 */
    radial-gradient(circle at center, rgba(29, 50, 90, 0.7) 0%, transparent 70%);
  /* 3. 网格线条（细线条，低透明度） */
  background-size: 100% 100%, 40px 40px, 40px 40px;
  filter: blur(50px);
  /* 模糊程度（数值越大越发散） */
  // opacity: 0.9;
  /* 控制色块透明度，避免过于浓重 */
  z-index: 0;

}

.back-root::before {
  content: "";
  position: fixed;
  top: 50%;
  left: 50%;
  width: 800px;
  height: 800px;
  background: radial-gradient(circle, rgba(29, 50, 90, 0.4) 0%, transparent 70%);
  filter: blur(60px);
  transform: translate(-50%, -50%);
  z-index: 0;
  opacity: 0.6;
}

.trend-card {
  // background: radial-gradient( 73% 73% at 46% 0%, #304C7E 0%, rgba(48,76,126,0) 100%);
}

:deep(.tooltip-box) {
  // border-radius: 0px 0px 0px 0px;
  // border: 2px solid #0E6FB8;
  position: relative;
  min-width: 220px;
  // min-height: 100px;
  // line-height: 32px;
  padding: 5px 10px;
  background: #115398;

  .tip-b-t {
    position: absolute;
    width: 50%;
    height: 2px;
    top: -3px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, #02DDEA 0%, #FFFFFF 53%, #00F2FF 100%);
    border-radius: 0px 0px 0px 0px;
  }

  .tip-b-l {
    position: absolute;
    width: 2px;
    height: 80%;
    top: 50%;
    left: -3px;
    transform: translateY(-50%);
    background: linear-gradient(180deg, #02DDEA 0%, #FFFFFF 53%, #00F2FF 100%);
    border-radius: 0px 0px 0px 0px;
  }

  .tip-b-r {
    position: absolute;
    width: 2px;
    height: 80%;
    top: 50%;
    right: -3px;
    transform: translateY(-50%);
    background: linear-gradient(180deg, #02DDEA 0%, #FFFFFF 53%, #00F2FF 100%);
    border-radius: 0px 0px 0px 0px;
  }

  .tip-b-b {
    position: absolute;
    width: 50%;
    height: 2px;
    bottom: -3px;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(90deg, #02DDEA 0%, #FFFFFF 53%, #00F2FF 100%);
    border-radius: 0px 0px 0px 0px;
  }

  .tip-line {
    position: absolute;
    // top: 100%;
    // left: -50%;
    width: 34px;
  }

  .tip-content {
    width: 100%;

    // max-height: 300px;
    // overflow-y: auto;
    .tip-title {
      display: flex;
      justify-content: space-between;
    }

    .tip-tag {
      display: inline-block;
      width: 8px;
      height: 8px;
      // background: #0A84FF;
      border-radius: 100px 100px 100px 100px;
    }
  }
}

.overview-stats {
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: #121D34;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid;
  opacity: 0.9;
  width: 100%;
  border-image: linear-gradient(45deg, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.06)) 1 1;

  .stat-item {
    text-align: left;
    padding: 10px;
    display: flex;
    align-items: center;
    gap: 5px;

    img {
      width: 40px;
    }

    .stat-value {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 20px;
      color: #B9E8FF;
      margin-bottom: 5px;
      margin-right: 5px;
    }

    .stat-label,
    span {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #B2D1FF;
    }
  }
}

/* 第二行卡片布局 */
.hospital-info-card,
.success-rate-card {
  width: calc(100% / 2);
  margin-top: 0;
  gap: 15px;
  // background-color: #0c192f;
  position: relative;
  // max-height: 380px;
}

.hospital-info-card {
  display: flex;

  .hospital-stats {
    display: flex;
    flex-direction: column;
    background: #121D34;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid;
    opacity: 0.9;
    white-space: nowrap;
    padding: 20px 30px 20px 20px;
    border-image: linear-gradient(45deg, rgba(255, 255, 255, 0.42), rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.06)) 1 1;
  }

  .stat-item {
    text-align: left;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;

    img {
      width: 40px;
    }

    .stat-value {
      font-family: Roboto, Roboto;
      font-weight: bold;
      font-size: 20px;
      color: #B9E8FF;
      margin-bottom: 5px;
      margin-right: 5px;
    }

    .stat-label,
    span {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #B2D1FF;
    }
  }
}

.hospital-stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stat-icon {
  font-size: 1.5rem;
  color: #0ea5e9;
}

.hospital-charts {
  flex: 1;
  display: flex;
  gap: 15px;
  height: calc(100% - 100px);
  max-height: 700px;
}

.chart-item {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.chart-title {
  font-size: 0.9rem;
  color: #94a3b8;
  margin-bottom: 8px;
}

/* 第三行和第四行卡片布局 */
.error-rate-card,
.visitor-distribution-card,
.average-visitor-card,
.visitor-count-card {
  width: 50%;
}

.visitor-distribution-card {
  background-color: #101e38;
  position: relative;
}

.error-rate-card {
  // background-color: #0c192f;
}

// 弹框设置
:deep(.ant-modal-content) {
  background: linear-gradient(180deg, #063566, #051120);
  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.05), 0px 15px 35px -2px rgba(0, 0, 0, 0.05);
  border-radius: 16px 16px 16px 16px;
  border: 2px solid #0A84FF;

  .ant-modal-header {
    background: none;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    border-bottom: none;

    .ant-modal-title {
      color: #FFFFFF;

    }
  }

  .ant-modal-close {
    color: #FFFFFF;
    opacity: 0.7;

  }

  .select-title {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #FFFFFF;
    line-height: 22px;
    opacity: 0.7;

  }

  .ant-modal-body {
    padding: 0 24px 24px 24px;

    .picker {
      margin-top: 6px;

      .ant-calendar-picker-input {
        background: rgba(10, 132, 255, 0.5);
        border-radius: 4px 4px 4px 4px;
        border: 1px solid rgba(10, 132, 255, 0.6);
        // font-weight: 400;
        // font-size: 13px;
        // color: #737A87;
      }

      .ant-input {
        color: #FFFFFF;
        opacity: 0.7;
      }
    }

    // padding: 24px;
    .select {
      margin-top: 8px;
    }

    .ant-select-selection {
      background: rgba(10, 132, 255, 0.5);
      border-radius: 4px 4px 4px 4px;
      border: 1px solid rgba(10, 132, 255, 0.6);
    }

    .ant-select-selection__rendered {
      color: #FFFFFF;
      opacity: 0.7;
    }

    .ant-select-arrow {
      color: #FFFFFF;
      opacity: 0.7;

    }
  }

  .ant-modal-footer {
    border-top: none;
    padding-top: 0;

    .ant-btn {
      // box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px #DDE2E9;
      border-radius: 4px 4px 4px 4px;
      background-color: #061325;
      border-color: #004EA2;
      border: 1px solid #0A84FF;
      color: #FFFFFF;
      opacity: 0.7;
    }

    .ant-btn-primary {
      background-color: #0A84FF;
      border-color: #0A84FF;
    }
  }
}
</style>